/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Plx from 'react-plx';

import { Grid, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createOurValuesSectionStyles } from './OurValuesSection.styles';

const parallaxData = [
  {
    start: '.plxServicesBlock',
    duration: '40vh',
    properties: [
      {
        startValue: -40,
        endValue: 0,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
];

export const OurValuesSection = memo(() => {
  const classes = createOurValuesSectionStyles();
  const { t } = useTranslation(Namespaces.About);

  return (
    <div className={cx(classes.root)}>
      <Plx className={cx('plxServicesBlock', classes.plxServicesBlock)} parallaxData={parallaxData}>
        <Grid container classes={{ root: classes.container }}>
          <Typography variant="h1" classes={{ root: classes.title }}>
            {t('our_values.title')}
          </Typography>
        </Grid>
        <div className={classes.container}>
          <Grid container spacing={5}>
            {[0, 1, 2, 3, 4, 5].map((link, i) => {
              return (
                <Grid item key={i} md={6}>
                  <div className={classes.card}>
                    <Typography variant="h2" classes={{ root: classes.cardTitle }}>
                      {t(`our_values.service_${i + 1}.title`)}
                    </Typography>
                    <Typography variant="body1" classes={{ root: classes.cardText }}>
                      <Trans>{t(`our_values.service_${i + 1}.text`)}</Trans>
                    </Typography>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </Plx>
    </div>
  );
});
